import * as t from 'io-ts';

import { TMethod } from '../src/method';

import { User } from './w4d-user-types';

type Params = {
  get: TMethod;
  put: TMethod;
  post: TMethod;
  patch: TMethod;
  postForm: TMethod;
  apiHost: string;
};

const w4dUserRemoteAPI = ({ get, apiHost }: Params) => ({
  readUser: {
    path: `${apiHost}/v6/user`,
    response: t.type({
      user: User,
    }),
    method: get,
  },
});

export { w4dUserRemoteAPI };
